// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__iWGNJ","title":"Header_title__ZrgFG","expanded":"Header_expanded__ofc3O"};